import React from "react";
import { AiOutlineWarning } from "react-icons/ai";
import "../../styles/DeleteConfirmationModal.css";

const RevokeConfirmationModal = ({ isOpen, onClose, onConfirm, itemName }) => {
    if (!isOpen) return null;

    return (
        <div className="delete-confirmation-modal-overlay">
            <div className="delete-confirmation-modal-content">
                <div className="delete-confirmation-modal-header">
                    <div className="delete-confirmation-modal-header-info">
                        <h2 className="delete-confirmation-modal-title">Potwierdzenie</h2>
                    </div>
                    <button className="delete-confirmation-close-btn" onClick={onClose}>✕</button>
                </div>

                <div className="delete-confirmation-modal-body">
                    <div className="delete-confirmation-message">
                        <div className="delete-confirmation-icon revoke-icon-color">
                            <AiOutlineWarning />
                        </div>
                        <p className="delete-confirmation-text">
                            Czy na pewno chcesz cofnąć ukończenie ćwiczenia <strong>{itemName}</strong>?
                        </p>
                        <span className="delete-confirmation-subtext">
                            Ćwiczenie zostanie oznaczone jako nieukończone.
                        </span>
                    </div>
                </div>

                <div className="delete-confirmation-modal-footer">
                    <button className="delete-confirmation-cancel-btn" onClick={onClose}>
                        Anuluj
                    </button>
                    <button className="delete-confirmation-delete-btn revoke-btn" onClick={onConfirm}>
                        Cofnij ukończenie
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RevokeConfirmationModal;